import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { FormItemType } from '../../../Standings/HelperClass/FormItem'
import Line from './Line'

type RectangleLineProps = {
    currentForm: FormItemType
    nextForm: FormItemType
}

export const getHeight = (currentForm: FormItemType, nextForm: FormItemType): number => {
    if (currentForm === nextForm) {
        return 3
    } else if (currentForm === 'DRAW' || nextForm === 'DRAW') {
        return 30
    }
    return 60
}

export const getOffset = (currentForm: FormItemType, nextForm: FormItemType): number => {
    if (currentForm === 'WIN' || nextForm === 'WIN') {
        return 38
    } else if (currentForm === 'DRAW' || nextForm === 'DRAW') {
        return 68
    }
    return 99
}

export const getDirection = (
    currentForm: FormItemType,
    nextForm: FormItemType
): 'UP' | 'DOWN' | 'SAME' => {
    if (currentForm === nextForm) {
        return 'SAME'
    }
    if (currentForm === 'WIN') {
        return 'DOWN'
    }
    if (currentForm === 'LOST') {
        return 'UP'
    }
    if (currentForm === 'DRAW' && nextForm === 'LOST') {
        return 'DOWN'
    }
    return 'UP'
}

const RectangleLine: FunctionComponent<RectangleLineProps> = ({ currentForm, nextForm }) => {
    const height = getHeight(currentForm, nextForm)
    const offset = getOffset(currentForm, nextForm)
    const direction = getDirection(currentForm, nextForm)

    return (
        <Grid marginTop={offset} height={height} center>
            <Line direction={direction} />
        </Grid>
    )
}
export default RectangleLine
